module.exports = __webpack_public_path__ + "img/8_37.7dae4cf7.png";